import axiosInstance from '../axiosInstance';

export type PostCaptionLabel = { id: string; name: string };

export type PostCaptionPayload = {
  post_title: string;
  post_caption: string;
  labels: PostCaptionLabel[];
};

export type SelectedHashtag = { id: string; name: string };

export type PostCaptionResponse = {
  /**
   * AI service may return either:
   * - string[] of tag names, or
   * - {id,name}[] (older shape)
   */
  selected_hashtags: string[] | SelectedHashtag[];
  recommended_hashtags: string[];
};

export async function postCaption(
  payload: PostCaptionPayload,
  tenantId?: string
): Promise<PostCaptionResponse> {
  const body = {
    post_title: String(payload.post_title ?? '').trim(),
    post_caption: String(payload.post_caption ?? '').trim(),
    labels: (payload.labels || []).map((l) => ({
      id: String(l.id ?? ''),
      name: String(l.name ?? ''),
    })),
  };

  const { data } = await axiosInstance.post<PostCaptionResponse>(
    '/api/v1/ai-tagging/post-caption',
    body,
    tenantId
      ? {
          headers: {
            'x-tenant-id': tenantId,
          },
        }
      : undefined
  );

  return data;
}
